import { clone, delay } from "./client";
import { api, USE_MOCK_API } from "./http";
import { MOCK_PROFILE } from "./mock-data";
import type { Address, Profile } from "./types";

let profile: Profile = clone(MOCK_PROFILE);
let addresses: Address[] = [];

/** GET /api/auth/me/profile */
export async function getProfile(): Promise<Profile> {
  if (!USE_MOCK_API) return api.get<Profile>("/auth/me/profile");
  return delay(clone(profile), 200);
}

/** PATCH /api/auth/me/profile */
export async function updateProfile(next: Profile): Promise<Profile> {
  if (!USE_MOCK_API) return api.patch<Profile>("/auth/me/profile", next);
  profile = clone(next);
  return delay(clone(profile), 420);
}

/** GET /api/auth/me/addresses */
export async function getAddresses(): Promise<Address[]> {
  if (!USE_MOCK_API) return api.get<Address[]>("/auth/me/addresses");
  return delay(clone(addresses), 180);
}

/** POST | PATCH /api/auth/me/addresses[/:id] */
export async function saveAddress(input: Partial<Address>): Promise<Address> {
  if (!USE_MOCK_API) {
    return input.id
      ? api.patch<Address>(`/auth/me/addresses/${encodeURIComponent(input.id)}`, input)
      : api.post<Address>("/auth/me/addresses", input);
  }
  const row = { id: input.id ?? `addr-${Date.now()}`, ...input } as Address;
  addresses = input.id
    ? addresses.map((a) => (a.id === input.id ? row : a))
    : [...addresses, row];
  return delay(clone(row), 300);
}

/** DELETE /api/auth/me/addresses/:id */
export async function deleteAddress(id: string): Promise<void> {
  if (!USE_MOCK_API) {
    await api.del<void>(`/auth/me/addresses/${encodeURIComponent(id)}`);
    return;
  }
  addresses = addresses.filter((a) => a.id !== id);
  return delay(undefined, 200);
}
